import { useRef } from 'react';

import { FormHandles } from '@unform/core';

import { DayPicker, Layout } from '~/components';
import ContainerDate from '~/components/ContainerDate';
import { useAuth } from '~/hooks/auth';

import { Card } from './Card';
import { getCardList } from './constants';

import { CardsContainer, Container, DateFilters } from './styles';

function ManagerReport() {
  const formRef = useRef<FormHandles>(null);

  const { user } = useAuth();

  const cardData = getCardList(user.professional.id);

  const handleGetFormValues = () => {
    const values = formRef?.current?.getData();
    return values;
  };

  return (
    <Layout title="Manager Report">
      <Container>
        <DateFilters
          id="edit-package"
          ref={formRef}
          onSubmit={() => console.log('opa')}
        >
          <ContainerDate label="Data início">
            <DayPicker
              name="initial_date"
              fieldLabel=""
              onChange={(e) => console.log('opa:', e)}
            />
          </ContainerDate>

          <ContainerDate label="Data final">
            <DayPicker
              name="final_date"
              fieldLabel=""
              onChange={(e) => console.log('opa:', e)}
            />
          </ContainerDate>
        </DateFilters>

        <CardsContainer>
          {cardData.map((data) => (
            <Card
              key={data.id}
              data={data}
              getDateFilterValues={handleGetFormValues}
            />
          ))}
        </CardsContainer>
      </Container>
    </Layout>
  );
}

export default ManagerReport;
